"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drop = void 0;
/**
 * drop a particular value from an array
 */
function drop(array, value) {
    return array.filter(v => v !== value);
}
exports.drop = drop;
//# sourceMappingURL=drop.js.map